<mat-form-field>
    <mat-select [formControl]="stateControl" placeholder="State">
        <mat-optgroup *ngFor="let stateGroup of stateGroups" [label]="stateGroup.label">
            <mat-option *ngFor="let state of stateGroup.members" [value]="state.abbreviation">
                {{state.abbreviation + ' - ' + state.name}}</mat-option>
        </mat-optgroup>
    </mat-select>
</mat-form-field>